<div class="grid-fluid">
  <div class="cell cell-large-col-span-12 flex flex-justify-center padding-vertical-xbig bg-black flex flex-column text-center">
    <div class="grid padding-horizontal-medium">
      <div class="cell cell-large-col-span-12 text-center">
        <h1 class="display-small margin-bottom-xmedium text-white" [innerHTML]="data.settings?.heading"></h1>
        <p class="body text-white" [innerHTML]="data.settings?.content"></p>
      </div>
  </div>
</div>